import { Link } from 'react-router-dom';
import { FaLinkedin, FaTwitter, FaFacebook, FaInstagram, FaLightbulb, FaCogs, FaRocket, FaCheckCircle, FaStar } from 'react-icons/fa';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      {/* About Hero Section */}
      <section className="about-hero section" data-aos="fade-up">
        <div className="container">
          <div className="about-hero-content">
            <h1>About <span className="text-gradient">Triology Business Lab</span></h1>
          </div>
        </div>
      </section>

      {/* Partner Section */}
      <section className="partner-section section" data-aos="fade-up">
        <div className="container">
          <div className="partner-content">
            <div className="partner-profile">
              <div className="profile-image" data-aos="zoom-in" data-aos-delay="200">
                <img src="/assets/images/img-3.jpg" alt="Consultant Profile" />
              </div>
              <div className="profile-bio">
                <p>
                  Triology Business Labs is a management and digital consulting firm that partners with organizations navigating growth, complexity, and transformation. We work closely with founders, CXOs, and leadership teams to bring clarity, structure, and execution discipline into the organization.
                </p>
                <p>
                  Our work is grounded in the belief that sustainable performance begins with organizational clarity clarity of purpose, priorities, systems, and ownership.
                </p>

                <div className="social-links">
                  <a href="https://www.linkedin.com/company/110027157/admin/dashboard/" target="_blank" rel="noopener noreferrer" className="social-link"><FaLinkedin /></a>
                  {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link"><FaTwitter /></a> */}
                  <a href="https://www.facebook.com/profile.php?id=61583750480170" target="_blank" rel="noopener noreferrer" className="social-link"><FaFacebook /></a>
                  <a href="https://www.instagram.com/triologysolutions/" target="_blank" rel="noopener noreferrer" className="social-link"><FaInstagram /></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Our Origin & Belief Section */}
      <section className="beliefs-section section" data-aos="fade-up">
        <div className="container">
          <div className="beliefs-header">
            <span className="section-label">OUR ORIGIN & BELIEF</span>
            <h2>Why Triology Exists</h2>
          </div>

          <div className="origin-content">
            <p className="origin-intro">
              Triology was founded on a simple but powerful insight:
            </p>

            <div className="origin-grid">
              <div className="origin-left">
                <p className="origin-quote">
                  Most organizational challenges are not due to lack of talent or intent, but due to misalignment between leadership intent, systems, and execution.
                </p>
              </div>
              <div className="origin-right">
                <p className="origin-description">
                  As organizations grow, complexity increases faster than clarity. Decisions slow down, accountability blurs, and execution becomes inconsistent. Triology exists to help organizations pause, diagnose, and realign before accelerating further.
                </p>
              </div>
            </div>

            <p className="origin-belief">
              We believe businesses are living systems within society, and when they operate with clarity and alignment, their impact extends far beyond financial results.
            </p>

            <div className="purpose-highlight-box">
              <h3 className="purpose-title">Our Purpose</h3>
              <p className="purpose-text">
                We serve as a catalyst in the creation of highly evolved organizations organizations that operate with clarity, strong leadership, disciplined systems, and sustainable execution.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How We Work Section */}
      <section className="how-we-work-section section" data-aos="fade-up">
        <div className="container">
          <div className="beliefs-header" style={{ textAlign: 'center' }}>
            <span className="section-label">HOW WE WORK</span>
            <h2>Partners in Transformation, Not External Advisors</h2>
          </div>

          <div className="work-content" style={{ width: '100%', margin: '0 auto', textAlign: 'center' }}>
            <p className="work-intro-text">
              Triology consultants work alongside leadership and core teams not at a distance. We believe meaningful transformation happens when thinking, decision-making, and execution are shared.
            </p>

            <div className="role-grid">
              <div className="role-card">
                <div className="role-number">01</div>
                <div className="role-icon-wrapper">
                  <FaLightbulb />
                </div>
                <p className="role-description">
                  Bring clarity to complex situations
                </p>
              </div>
              <div className="role-card">
                <div className="role-number">02</div>
                <div className="role-icon-wrapper">
                  <FaCogs />
                </div>
                <p className="role-description">
                  Design practical, context-specific systems
                </p>
              </div>
              <div className="role-card">
                <div className="role-number">03</div>
                <div className="role-icon-wrapper">
                  <FaRocket />
                </div>
                <p className="role-description">
                  Enable leaders and teams to execute with confidence
                </p>
              </div>
            </div>

            <div className="success-metric">
              <p style={{ fontSize: '1.3rem', color: 'var(--text-primary)', fontWeight: '600', lineHeight: '1.6', margin: 0 }}>
                "We measure success not by recommendations delivered, but by outcomes achieved and capabilities built."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Team Section */}
      <section className="team-section section" data-aos="fade-up">
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="beliefs-header">
            <h3 style={{ fontSize: '1rem', textTransform: 'uppercase', color: 'var(--primary-color)', marginBottom: '0.5rem', fontWeight: '700' }}>OUR TEAM</h3>
            <h2>A Multidisciplinary Consulting Team</h2>
          </div>

          <div className="team-content" style={{ width: '100%', margin: '0 auto' }}>
            <p style={{ fontSize: '1.15rem', color: 'var(--text-secondary)', marginBottom: '1.5rem', lineHeight: '1.7' }}>
              Triology is powered by a team of management consultants, business analysts, and execution specialists with experience across industries and growth stages.
            </p>

            <p style={{ fontSize: '1.15rem', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '1rem' }}>
              Our team combines:
            </p>

            <ul className="team-list">
              <li><FaCheckCircle className="team-check" /> Strategic and analytical rigor</li>
              <li><FaCheckCircle className="team-check" /> Hands-on execution experience</li>
              <li><FaCheckCircle className="team-check" /> System and process thinking</li>
              <li><FaCheckCircle className="team-check" /> A conscious, responsible approach to leadership and consulting</li>
            </ul>

            <div style={{ marginTop: '2rem', padding: '1.5rem', borderTop: '1px solid var(--border-color)' }}>
              <p style={{ fontSize: '1.15rem', color: 'var(--text-primary)', fontWeight: '500', lineHeight: '1.6', margin: 0, fontStyle: 'italic' }}>
                "We operate as integrated project teams, ensuring continuity, accountability, and depth in every engagement."
              </p>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '3rem' }}>
            <Link to="/contact" className="cta-button">
              Book TRIOLOGY Journey →
            </Link>
          </div>
        </div>
      </section>

      {/* What Makes Us Different Section */}
      <section className="difference-section section" data-aos="fade-up">
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="beliefs-header">
            <h3 style={{ fontSize: '1rem', textTransform: 'uppercase', color: 'var(--primary-color)', marginBottom: '0.5rem', fontWeight: '700' }}>WHAT MAKES US DIFFERENT</h3>
            <h2>The Triology Difference</h2>
          </div>

          <div className="difference-content" style={{ width: '100%', margin: '0 auto', textAlign: 'left' }}>
            <p style={{ fontSize: '1.25rem', color: 'var(--text-secondary)', marginBottom: '2rem', lineHeight: '1.8', textAlign: 'center' }}>
              Clients choose Triology because we offer:
            </p>

            <div className="difference-list">
              {[
                "a diagnosis-led consulting approach",
                "structured execution governance through COSMOS",
                "deep involvement rather than advisory distance",
                "balance between leadership consciousness and operational rigor",
                "focus on long-term capability, not short-term fixes"
              ].map((item, index) => (
                <div key={index} className="difference-card">
                  <div className="diff-icon"><FaStar /></div>
                  <div className="diff-text">{item}</div>
                </div>
              ))}
            </div>

            <div style={{ marginTop: '3rem', textAlign: 'center' }}>
              <p style={{ fontSize: '1.3rem', color: 'var(--text-primary)', fontWeight: '500', lineHeight: '1.6', margin: 0, fontStyle: 'italic', maxWidth: '800px', marginInline: 'auto' }}>
                "We are selective about the organizations we work with, because transformation requires commitment on both sides."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Building Organizations Section */}
      <section className="building-org-section section" data-aos="fade-up">
        <div className="container">
          <div className="building-card">
            <h2 className="building-title">Building Organizations That Can Sustain Growth</h2>

            <p className="building-text">
              Triology partners with organizations that are ready to bring clarity to their systems, alignment to their leadership, and discipline to their execution.
            </p>

            <span className="highlight-text">
              Our work is not about accelerating blindly <br />
              it is about ensuring the organization is truly ready to scale.
            </span>

            <div style={{ textAlign: 'center', marginTop: '2.5rem' }}>
              <Link to="/contact" className="cta-button">
                Explore Our Approach →
              </Link>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
};

export default About;
